import { PRODUCT_LOADED } from 'redux/modules/product-details/actions/types';

import productDetails from './product-details';

export default {
  [PRODUCT_LOADED]: productDetails,
};
